import { render, staticRenderFns } from "./RedSection.vue?vue&type=template&id=8674182a&scoped=true"
import script from "./RedSection.vue?vue&type=script&lang=js"
export * from "./RedSection.vue?vue&type=script&lang=js"
import style0 from "./RedSection.vue?vue&type=style&index=0&id=8674182a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8674182a",
  null
  
)

export default component.exports